import * as APPDATA from '@/constants/pcConstAppData';

export const goToAdvSetupExplorerScreen = () => {
  window.location.href = APPDATA.ADVANCE_SETUP_EXPLORER;
};

export const goToAutoSetupScreen = () => {
  window.location.href = APPDATA.AUTO_PROFILE_SETUP;
};
